(function () {
  'use strict';

  /* @ngdoc object
   * @name plantProtection.exports
   * @description
   *
   */
  angular
    .module('plantProtection.exports', [
      'ui.router',
      'plantProtection.exports.edit'
    ]);
}());
